import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { Search } from 'lucide-react';
import { SortOption } from './RecipeFilters';

interface MobileRecipeFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  sortBy: SortOption;
  onSortChange: (sort: SortOption) => void;
  selectedTags?: string[];
  onTagRemove?: (tag: string) => void;
}

const MobileRecipeFilters: React.FC<MobileRecipeFiltersProps> = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  selectedTags = [],
  onTagRemove,
}) => {
  return (
    <div className="space-y-3 mb-4">
      {/* Search */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search recipes..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 h-9"
        />
      </div>

      {/* Sort Dropdown */}
      <Select value={sortBy} onValueChange={(value) => onSortChange(value as SortOption)}>
        <SelectTrigger className="w-full h-9">
          <SelectValue placeholder="Sort by..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="date-desc">Newest First</SelectItem>
          <SelectItem value="date-asc">Oldest First</SelectItem>
          <SelectItem value="alphabetical-asc">A to Z</SelectItem>
          <SelectItem value="alphabetical-desc">Z to A</SelectItem>
          <SelectItem value="usage-desc">Most Used</SelectItem>
          <SelectItem value="usage-asc">Least Used</SelectItem>
        </SelectContent>
      </Select>

      {/* Selected Tags */}
      {selectedTags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {selectedTags.map((tag, index) => (
            <Badge 
              key={index}
              variant="secondary" 
              className="text-xs bg-primary/10 text-primary border-primary/20 cursor-pointer hover:bg-primary/20"
              onClick={() => onTagRemove?.(tag)}
            >
              {tag} ×
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileRecipeFilters;